import { useCallback, type FC } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "@/ds/custom/Modal";
import { Emblem } from "@/features/common/components/Emblem";
import { useStorage } from "@/lib/storage";
import { Button } from "@/ds/shadcn/components/ui/button";

export interface ModalEmblemsExplainProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const ModalEmblemsExplain: FC<ModalEmblemsExplainProps> = props => {
	const {
		open,
		onOpenChange
	} = props;

	const storage = useStorage();

	const onClose = useCallback(() => {
		storage.setPersistent("hasDisplayed2026EmblemSetModal", true);
		onOpenChange(false);
	}, [onOpenChange, storage]);

	return (
		<Modal open={open} onOpenChange={onOpenChange}>
			<ModalHeader>
				<ModalTitle>Welcome to Emblems 2026!</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className="flex flex-col gap-4">
					<div className="flex gap-3 justify-center">
						<div className="w-14 h-14"><Emblem emblemId="SKY_FIRE_LANTERNS" rarity="Common" count={1} /></div>
						<div className="w-14 h-14"><Emblem emblemId="BENEATH_THE_SURFACE" rarity="Rare" count={1} /></div>
						<div className="w-14 h-14"><Emblem emblemId="ACT_OF_GLORY" rarity="Majestic" count={1} /></div>
						<div className="w-14 h-14"><Emblem emblemId="NEW_HORIZON" rarity="Legendary" count={1} /></div>
						<div className="w-14 h-14"><Emblem emblemId="ARKNIGHT_SHARD" rarity="Fabled" count={1} /></div>
					</div>

					<p className="type-description">
						Welcome to another year of Fyendal&apos;s Collection emblems!
					</p>

					<p className="type-description">
						We&apos;ve hand-picked a brand new set
						of Emblems for you to roll in 2026. Like last year, these emblems are
						tracked separately from the previous sets, so you can
						continue to collect the old ones if you wish.
					</p>

					<div className="flex gap-3 justify-center">
						<div className="w-14 h-14"><Emblem emblemId="PINK_VISOR" rarity="Special" count={1} /></div>
						<div className="w-14 h-14"><Emblem emblemId="POPPED_COLLAR_POLO" rarity="Special" count={1} /></div>
						<div className="w-14 h-14"><Emblem emblemId="TAYLOR" rarity="Special" count={1} /></div>
					</div>

					<p className="type-description">
						This year brings an additional set of <i>Special Emblems</i> which
						are unlocked by completing certain objectives on
						the Fyendal&apos;s Collection website. You can&apos;t
						roll these emblems, so head to the new "Special Emblems"
						section in the drop-down to learn how you can obtain
						them!
					</p>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button onClick={onClose}>Got it!</Button>
			</ModalFooter>
		</Modal>
	);
};
